/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */

import "phaser";
import { Button } from "../Entities/GlobalEntities"
import {
    getTopScores,
    getMyAddress,
} from "../../../web3/SFM-ScoreBoardContract_Utils";
import {
    getAllTeams,
    getMyTeam
} from "../../../web3/SFM-TeamsUtils";
import { AddImageToScene, loadImage, loadAudio ,processData } from "./../modules/utiltes"
import { SoundManager } from "../ScenesHelpers/SoundManager";

const commonStyle = {
    fontFamily: "monospace",
    fontStyle: "bold",
    color: "#ffffff",
    align: "center",
}



export class SceneTopScores extends Phaser.Scene {
    constructor() {
        super({
            key: "SceneTopScores",
        });
    }
    init(data) {
        // Access the mode parameter passed from Scene 1
        this.player = data.player;
        this.mode = data.mode;
    }
    preload() {
        loadImage(this, "topscore", "assets/img/game/Background-2.png")
        loadImage(this, "playagaintbtn", "assets/img/game/PlayAgain.png")
        loadImage(this, "Reconfigurationbtn", "assets/img/game/Reconfiguration.png")
        loadAudio(this, "topscores", "assets/img/game/topscores.wav")
    }

    async create() { 

        this.dataPoints = await processData(this.mode);
        if (this.mode === "off") {
            this.address = await getMyAddress();
            this.address =
                this.address.substring(0, 4) +
                "...." +
                this.address.substring(this.address.length - 4, this.address.length);
            this.currentScore = await this.player.getCurrentPlayerScore();
    
            let found = false;
            for (let i = 0; i < this.dataPoints.length; i++) {
                if (this.dataPoints[i].address === this.address) {
                    this.dataPoints[i].score += this.currentScore;
                    found = true;
                    break;
                }
            }
    
            if (!found) {
                this.dataPoints.push({
                    address: this.address,
                    score: this.currentScore,
                });
            }
        } else if (this.mode === "on") {
            const myTeam = await getMyTeam();
            const teamName = myTeam.name;
            let found = false;
            for (let i = 0; i < this.dataPoints.length; i++) {
                if (this.dataPoints[i].name === teamName) {                    
                    //@todo: update current team score
                    //@dev: The following line gives error: score is read only
                    //this.dataPoints[i].score += this.currentScore;
                    found = true;
                    break;
                }
            }
            if (!found) {
                console.error(`Something went wrong`);
            }
        }


        this.sfx = {
            topscores: SoundManager.createAudio(this, "topscores", 1, false)
        };
        this.sfx.topscores.play();
        this.bg = AddImageToScene(this, "topscore")
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.W);
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.S);
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.A);
        this.input.keyboard.removeCapture(Phaser.Input.Keyboard.KeyCodes.D);

        this.title = this.add.text(
            this.game.config.width * 0.5,
            128,
            "TOP SCORES", {
                fontFamily: commonStyle.fontFamily,
                fontSize: 48,
                fontStyle: commonStyle.fontStyle,
                color: commonStyle.color,
                align: commonStyle.align,
            }
        );
        this.title.setOrigin(0.5);

        ////////////////////////////////////////////////////
        this.playagaintbtn = new Button(this, 150, 600, "playagaintbtn");
        this.playagaintbtn.setInteractive();
        this.playagaintbtn.on("pointerdown", function(pointer) {
            this.setTint(0x6b128b);
        });
        this.playagaintbtn.on("pointerup", (pointer) => {
            this.scene.start('PayFeesScene')
        });
        this.playagaintbtn.on("pointerout", function(pointer) {
            this.clearTint();
        });
        //////////////////////////////////////////
        this.Reconfigurationbtn = new Button(this, 350, 600, "Reconfigurationbtn");
        this.Reconfigurationbtn.setInteractive();
        this.Reconfigurationbtn.on("pointerdown", function(pointer) {
            this.setTint(0x6b128b);
        });
        this.Reconfigurationbtn.on("pointerup", (pointer) => {
            window.location.reload()
        });
        this.Reconfigurationbtn.on("pointerout", function(pointer) {
            this.clearTint();
        });
        //////////////////////////////////////////
        const MAX_RENDERED_TEAMS = 5;
        let height = 0.3;
        const minLen = Math.min(this.dataPoints.length, MAX_RENDERED_TEAMS);
        for (let i = 0; i < minLen; i++) {
            let result = this.dataPoints[i];
            const title = this.mode === "off" ? result.address : result.name;
            this.add.text(
                this.game.config.width * 0.3,
                this.game.config.height * height,
                `${title}: ${result.score.toString()}`, {
                    fontFamily: commonStyle.fontFamily,
                    fontSize: 20,
                    fontStyle: commonStyle.fontStyle,
                    color: commonStyle.color,
                    align: commonStyle.align,
                }
            );
            height += 0.1;
        }
    }

    update() {}




}